import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import App from './App';
import configureStore from './store/configureStore';

if (window.location.origin.includes('https://app-stage.ava.me')) {
  LogRocket.init('xyqwjx/ava-scribe');
  setupLogRocketReact(LogRocket);
}

const isProd =
  window.location.href.indexOf('app.avascribe.com') > -1 ||
  window.location.href.indexOf('app.ava.me') > -1 ||
  window.location.href.indexOf('web.ava.me') > -1;

const branchName =
  new URL(window.location.href).pathname.indexOf('playground') > 1
    ? 'playground'
    : 'dev';
const hash = process.env.HASH_COMMIT;
// eslint-disable-next-line
console.log({
  hash,
  tag: process.env.TAG_COMMIT,
});

if (isProd || branchName === 'playground') {
  Sentry.init({
    dsn: 'https://598382256bd44dc7b175357bac4bc464@sentry.io/1303073',
    environment: isProd ? 'production' : branchName,
    release: hash,
  });
} else if (hash === 'dev') {
  Sentry.init({
    dsn: 'https://598382256bd44dc7b175357bac4bc464@sentry.io/1303073',
    environment: 'dev',
    release: hash,
  });
}

const store = configureStore();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
